export const psc2Team = [
  {
    label: "Đội dịch vụ sân đỗ",
    value: "SD1|Đội dịch vụ sân đỗ",
  },
  {
    label: "Đội dịch vụ kỹ thuật",
    value: "SD2|Đội dịch vụ kỹ thuật",
  },
  {
    label: "Đội cung ứng vật tư",
    value: "SD3|Đội cung ứng vật tư",
  },
  {
    label: "Đội dịch vụ trên tàu",
    value: "SD4|Đội dịch vụ trên tàu",
  },
  {
    label: "Văn phòng trung tâm phục sân đỗ",
    value: "SD5|Văn phòng trung tâm phục sân đỗ",
  },
];

export const pvhk2Team = [
  {
    label: "Đội phục vụ hành khách VNA quốc nội",
    value: "PVHK1|Đội phục vụ hành khách VNA quốc nội",
  },
  {
    label: "Đội phục vụ hành khách VNA quốc tế",
    value: "PVHK2|Đội phục vụ hành khách VNA quốc tế",
  },
  {
    label: "Đội phục vụ hành khách đến và chuyển tiếp",
    value: "PVHK3|Đội phục vụ hành khách đến và chuyển tiếp",
  },
  {
    label: "Đội vé sân bay",
    value: "PVHK4|Đội vé sân bay",
  },
  {
    label: "Đội phục vụ hành khách quốc tế 1",
    value: "PVHK5|Đội phục vụ hành khách quốc tế 1",
  },
  {
    label: "Đội phục vụ hành lý",
    value: "PVHK6|Đội phục vụ hành lý",
  },
  {
    label: "Văn phòng trung tâm phục vụ hành khách",
    value: "PVHK7|Văn phòng trung tâm phục vụ hành khách",
  },
];

export const hq2Team = [
  {
    label: "Trực ban điều hành",
    value: "HQ1|Trực ban điều hành",
  },
  {
    label: "Đội hướng dẫn chất xếp",
    value: "HQ2|Đội hướng dẫn chất xếp",
  },
  {
    label: "Đội xe đưa đón phi công tiếp viên",
    value: "HQ3|Đội xe đưa đón phi công tiếp viên",
  },
  {
    label: "Đội xe điều hành",
    value: "HQ4|Đội xe điều hành",
  },
  {
    label: "Tổ quản lý chất lượng ",
    value: "HQ5|Tổ quản lý chất lượng ",
  },
  {
    label: "Văn phòng trung tâm điều hành",
    value: "HQ6|Văn phòng trung tâm điều hành",
  },
];

export const hq1Team = [
  {
    label: "Trực ban điều hành",
    value: "HQ1|Trực ban điều hành",
  },
  {
    label: "Đội hướng dẫn chất xếp",
    value: "HQ2|Đội hướng dẫn chất xếp",
  },
  {
    label: "Tổ quản lý chất lượng ",
    value: "HQ5|Tổ quản lý chất lượng ",
  },
  {
    label: "Đội xe phục vụ tổ bay",
    value: "HQ6|Đội xe phục vụ tổ bay",
  },
  {
    label: "Văn phòng trung tâm điều hành",
    value: "HQ7|Văn phòng trung tâm điều hành",
  },
];

export const psc1Team = [
  {
    label: "Đội dịch vụ sân đỗ",
    value: "SD1|Đội dịch vụ sân đỗ",
  },
  {
    label: "Đội dịch vụ kỹ thuật",
    value: "SD2|Đội dịch vụ kỹ thuật",
  },
  {
    label: "Đội cung ứng vật tư",
    value: "SD3|Đội cung ứng vật tư",
  },
  {
    label: "Đội dịch vụ trên tàu",
    value: "SD4|Đội dịch vụ trên tàu",
  },
  {
    label: "Văn phòng trung tâm phục vụ sân đỗ",
    value: "SD5|Văn phòng trung tâm phục vụ sân đỗ",
  },
];

export const pvhk1Team = [
  {
    label: "Đội phục vụ hành khách VNA quốc nội",
    value: "PVHK1|Đội phục vụ hành khách VNA quốc nội",
  },
  {
    label: "Đội phục vụ hành khách VNA quốc tế",
    value: "PVHK2|Đội phục vụ hành khách VNA quốc tế",
  },
  {
    label: "Đội phục vụ hành khách đến và chuyển tiếp",
    value: "PVHK3|Đội phục vụ hành khách đến và chuyển tiếp",
  },
  {
    label: "Đội vé sân bay",
    value: "PVHK4|Đội vé sân bay",
  },
  {
    label: "Đội phục vụ hành lý",
    value: "PVHK6|Đội phục vụ hành lý",
  },
  {
    label: "Đội phục vụ hành khách các hãng",
    value: "PVHK7|Đội phục vụ hành khách các hãng",
  },
  {
    label: "Văn phòng trung tâm phục vụ hành khách",
    value: "PVHK8|Văn phòng trung tâm phục vụ hành khách",
  },
];

export const psc3Team = [
  {
    label: "Đội dịch vụ sân đỗ",
    value: "SD1|Đội dịch vụ sân đỗ",
  },
  {
    label: "Đội dịch vụ kỹ thuật",
    value: "SD2|Đội dịch vụ kỹ thuật",
  },
  {
    label: "Đội dịch vụ trên tàu",
    value: "SD4|Đội dịch vụ trên tàu",
  },
  {
    label: "Văn phòng trung tâm phục vụ sân đỗ",
    value: "SD5|Văn phòng trung tâm phục vụ sân đỗ",
  },
];

export const pvhk3Team = [
  {
    label: "Đội phục vụ hành khách VNA quốc nội",
    value: "PVHK1|Đội phục vụ hành khách VNA quốc nội",
  },
  {
    label: "Đội phục vụ hành khách VNA quốc tế",
    value: "PVHK2|Đội phục vụ hành khách VNA quốc tế",
  },
  {
    label: "Đội vé sân bay",
    value: "PVHK4|Đội vé sân bay",
  },
  {
    label: "Đội phục vụ hành lý",
    value: "PVHK6|Đội phục vụ hành lý",
  },
  {
    label: "Văn phòng trung tâm phục vụ hành khách",
    value: "PVHK7|Văn phòng trung tâm phục vụ hành khách",
  },
];

export const hq3Team = [
  {
    label: "Tổ quản lý chất lượng ",
    value: "HQ5|Tổ quản lý chất lượng ",
  },
  {
    label: "Đội điều hành",
    value: "HQ6|Đội điều hành",
  },
  {
    label: "Văn phòng trung tâm điều hành",
    value: "HQ7|Văn phòng trung tâm điều hành",
  },
];

export const systemTeams = [
  {
      "key": 0,
      "label": "Đội Phát triển CNTT",
      "value": "Đội Phát triển CNTT"
  },
  {
      "key": 6,
      "label": "Đội ĐBVH và Hạ Tầng CNTT",
      "value": "Đội ĐBVH và Hạ Tầng CNTT"
  },
  {
      "key": 15,
      "label": "Nhóm Đảm Bảo Vận Hành CNTT",
      "value": "Nhóm Đảm Bảo Vận Hành CNTT"
  },
  {
      "key": 20,
      "label": "Nhóm văn phòng công ty",
      "value": "Nhóm văn phòng công ty"
  },
  {
      "key": 29,
      "label": "Ban CNTT",
      "value": "Ban CNTT"
  },
  {
      "key": 30,
      "label": "AITS",
      "value": "AITS"
  },
  {
      "key": 31,
      "label": "TTĐH KT",
      "value": "TTĐH KT"
  },
  {
      "key": 33,
      "label": "Ban ATCL",
      "value": "Ban ATCL"
  },
  {
      "key": 34,
      "label": "Ban TTBSP",
      "value": "Ban TTBSP"
  },
  {
      "key": 35,
      "label": "Ban DVHK",
      "value": "Ban DVHK"
  }
]